export const ExpandMoreIcon = ({ classes, stroke = "#333", fill = "none" }) => (
  <svg width={20} height={20} className={classes} viewBox="0 0 20 20" fill={fill} xmlns="http://www.w3.org/2000/svg">
    <path d="M15 8L10 13L5 8" stroke={stroke} strokeMiterlimit={10} strokeLinecap="square" />
  </svg>
);
